import React from 'react';
import Async from 'react-select/async';
import { jobRoleStore } from '../../../settings/job-roles/JobRoleStore';
import {
	isActiveJobRole,
	isRetainedJobRole
} from '../../../settings/job-roles/activeJobRoles';
import MultiDropdownGroupedAsync from 'ats/components/multi-dropdown-grouped/MultiDropdownGroupedAsync';

export class JobRoleDropdown extends React.Component {
	state = {
		value: null,
		loaded: false
	};
	componentDidMount() {
		if (this.props.value) {
			this.setState({ value: this.props.value });
		}
		this.setState({ loaded: true });
	}

	render() {
		if (this.state.loaded) {
			const {
				placeholder = 'You can choose more than one option',
				isMulti = true
			} = this.props;
			// Multi-select uses the grouped async wrapper so currently selected
			// job roles are pinned at the top and the count pill is rendered.
			const Component = isMulti ? MultiDropdownGroupedAsync : Async;
			return (
				<Component
					menuPosition={this.props.menuPosition || 'fixed'}
					menuPlacement={this.props.menuPlacement || 'auto'}
					closeMenuOnScroll={this.props.closeMenuOnScroll}
					menuPortalTarget={this.props.menuPortalTarget}
					usePurpleStyles={
						this.props.styleVersion === 'ats' || this.props.usePurpleStyles
					}
					maxMenuHeight="300"
					className={
						'react-select ' +
						(isMulti ? 'ats-multi-dropdown ats-multi-dropdown-grouped ' : '') +
						(this.props.styleVersion ? this.props.styleVersion : '') +
						(this.props.isInvalid ? ' has-error' : '')
					}
					classNamePrefix={
						this.props.classNamePrefix ||
						'react-select' +
							(this.props.styleVersion ? `-${this.props.styleVersion}` : '')
					}
					cacheOptions
					isMulti={isMulti}
					value={
						this.props.value === undefined ? this.state.value : this.props.value
					}
					placeholder={placeholder}
					isDisabled={this.props.disabled}
					components={
						this.props.styleVersion === 'ats'
							? {
									IndicatorSeparator: null,
									DropdownIndicator: () => (
										<img src="/ats/icons/chevron-down-icon.svg" alt="" />
									)
								}
							: undefined
					}
					styles={
						this.props.styleVersion === 'ats'
							? {
									container: (base, state) => ({
										...base,
										...(state.isDisabled && {
											opacity: 0.5,
											cursor: 'not-allowed'
										})
									}),
									control: base => ({
										...base,
										paddingRight: 12,
										...(this.props.customStyles?.control || {})
									})
								}
							: undefined
					}
					defaultOptions
					loadOptions={this.loadOptions}
					getOptionValue={this.getOptionValue}
					getOptionLabel={this.getOptionLabel}
					noOptionsMessage={this.noOptionsMessage}
					onChange={item => {
						if (this.props.onValueChange) {
							this.props.onValueChange(item);
						}
						this.setState({ value: item });
					}}
				/>
			);
		} else {
			return null;
		}
	}

	loadOptions = inputValue => {
		return new Promise(resolve => {
			resolve(this.getJobRoles(inputValue));
		});
	};

	getJobRoles = async inputValue => {
		inputValue = inputValue.trim();
		const result = await jobRoleStore.getJobRoles(inputValue);
		// Filters and other read contexts can opt into showing legacy roles by
		// passing `includeLegacy`. Creation/edit forms keep the default behavior
		// and only offer roles from the active (new) list as selectable options.
		if (this.props.includeLegacy) {
			return result.data.filter(role => isRetainedJobRole(role.name));
		}
		return result.data.filter(role => isActiveJobRole(role.name));
	};

	noOptionsMessage = value => {
		if (value.inputValue && value.inputValue.length >= 1) {
			return 'No matches found';
		} else {
			return 'Enter text to search job roles';
		}
	};

	getOptionValue = option => option.id;

	getOptionLabel = option => `${option.name}`;
}
